/* eslint-disable import/prefer-default-export */
export { UploadStatus } from './leadFileUpload';

export const UNASSIGNED_ASSIGNEE = {
  id: 'unassigned',
  name: 'Unassigned',
  isUnassigned: true
};

export const INPUT_BASE_CLASSNAME =
  '!bg-theme border-grey40 border disabled:border-grey30 disabled:bg-grey10';

export const INPUT_FOCUS_CLASSNAME =
  'focus:outline-none focus:border-primary focus-within:border-primary focus:shadow-inputShadow';

export const INPUT_MAX_LENGTH = 50;
export const INPUT_MIN_LENGTH = 3;

export const MAX_LEAD_STATUS_COUNT = 15;
